import { LockClosedIcon } from '@heroicons/react/24/outline';
import { T } from '../../../../../../../Translations';

function SystemManagedIndicator() {
  return (
    <div
      data-testid="system-managed-indicator"
      data-intercom-target="system-managed-indicator"
      className="ml-3 flex items-center gap-2 h-[38px] px-4 bg-muted text-muted-foreground rounded-md"
    >
      <LockClosedIcon className="w-4 h-4" aria-hidden="true" />
      <span className="font-medium text-sm">
        <T kind="System Managed" />
      </span>
    </div>
  );
}

export default SystemManagedIndicator;
